import { observer } from "mobx-react-lite";
import Skeleton from "react-loading-skeleton";
import { useParams } from "wouter";

import { isDataAvailable, isDefaultData, isWaitingForData } from "../../common/utils/asyncDataUtils";

import contentStore from "../../stores/cms/contentStore";

import NotFound from "../NotFound";
import CmsContentFetchWrapper from "./CmsContentFetchWrapper";

const CmsContent = () => {
   const { fullUrl } = useParams();

   if (isWaitingForData(contentStore.urlData) || isDefaultData(contentStore.urlData)) {
      return <Skeleton height={500} />;
   }

   if (isDataAvailable(contentStore.urlData)) {
      const currentUrlData = contentStore.urlData.data.find((data) => data.fullUrl === fullUrl);
      if (currentUrlData) {
         return <CmsContentFetchWrapper key={`contentPage-${fullUrl}`} id={currentUrlData.id} />;
      }
   }

   return <NotFound />;
};

export default observer(CmsContent);
